import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header.tsx';
import Footer from '../components/Footer.tsx';
import { useRegister } from '../hooks/useRegister.ts';
import { getUserToken } from '../utils/helpers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import GoogleLoginButton from '../components/GoogleLoginButton.js';

const Register = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [localError, setLocalError] = useState(null);
  const { loading, error, data, register } = useRegister();
  const [loginSuccess, setLoginSuccess] = useState(false);

  const navigate = useNavigate();

  const userToken = getUserToken();
  // Funções para login social
  const handleGoogleLogin = () => {
    console.log('Google login clicked');
    // Implementar lógica de login com Google
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  const handleFacebookLogin = () => {
    console.log('Facebook login clicked');
    // Implementar lógica de login com Facebook
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/facebook`;
  };

  const handleLinkedInLogin = () => {
    console.log('LinkedIn login clicked');
    // Implementar lógica de login com LinkedIn
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/linkedin`;
  };

  useEffect(() => {
    if (userToken) {
      navigate("/dashboard");
    }
  }, [navigate, userToken]);

  async function handleSubmit(e) {
    e.preventDefault();
    setLocalError(null);

    if (password !== confirmPassword) {
      setLocalError('The passwords are not the same.');
      return;
    }

    const result = await register({ firstName, lastName, email, password });
    if (result) {
      navigate(`/verification/${btoa(email)}`);
    }
  }

  return (
    <>
      <Header />
      <section className="account padding-top padding-bottom sec-bg-color2">
        <div className="container">
          <div
            className="account__wrapper"
            data-aos="fade-up"
            data-aos-duration="800"
            style={{ display: 'contents' }}
          >
            <div className="account__inner">
              <div className="row align-items-center">
                {/* Coluna imagem */}
                <div className="col-lg-6">
                  <div className="account__thumb">
                    <img
                      src="/images/login/login1.png"
                      alt="Register illustration"
                      width={700}
                      height={200}
                      style={{
                        borderRadius: '20px',
                        boxShadow: '0 20px 40px rgba(0,0,0,0.1)'
                      }}
                    />
                  </div>
                </div>

                {/* Coluna formulário */}
                <div className="col-lg-6">
                  <div className="account__content account__content--style2">
                    {/* Header moderno */}
                    <div className="account__header text-center mb-5">
                      <div className="mb-4">
                        <div
                          style={{
                            width: '60px',
                            height: '60px',
                            background: '#00D094',
                            borderRadius: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 15px',
                            boxShadow: '0 10px 20px #00D094'
                          }}
                        >
                          <i className="fas fa-user-plus" style={{ color: 'white', fontSize: '24px' }}></i>
                        </div>
                        <h2
                          style={{
                            fontSize: '2.5rem',
                            color: '#fff',
                            marginTop: '30px',
                            marginBottom: '0px'
                          }}
                        >
                          Create Your Account
                        </h2>
                      </div>
                      <p
                        style={{
                          color: '#6c757d',
                          fontSize: '1.1rem',
                          lineHeight: '1.6'
                        }}
                      >
                        Join our platform and start managing your investments with AI-powered tools.
                      </p>
                    </div>

                    {/* Botões de Registro Social */}
                    {/* <div className="social-login mb-4">
                      <div className="row g-3">
                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn google-btn"
                            onClick={handleGoogleLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#db4437';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-google" style={{ color: '#db4437' }}></i>
                          </button>
                        </div>

                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn facebook-btn"
                            onClick={handleFacebookLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#4267B2';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-facebook-f" style={{ color: '#4267B2' }}></i>
                          </button>
                        </div>

                        <div className="col-4">
                          <button
                            type="button"
                            className="social-btn linkedin-btn"
                            onClick={handleLinkedInLogin}
                            style={{
                              width: '100%',
                              padding: '12px',
                              border: '2px solid #e0e0e0',
                              borderRadius: '12px',
                              background: 'white',
                              color: '#757575',
                              fontWeight: '600',
                              fontSize: '14px',
                              cursor: 'pointer',
                              transition: 'all 0.3s ease',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '8px'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.borderColor = '#0077b5';
                              e.currentTarget.style.transform = 'translateY(-2px)';
                              e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = '#e0e0e0';
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = 'none';
                            }}
                          >
                            <i className="fab fa-linkedin-in" style={{ color: '#0077b5' }}></i>
                          </button>
                        </div>
                      </div>
                    </div> */}

                    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
                      <GoogleLoginButton setLoginSuccess={setLoginSuccess} />
                    </GoogleOAuthProvider>

                    <div className="divider mb-4 mt-4">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          textAlign: 'center',
                          color: '#6c757d',
                          fontSize: '14px'
                        }}
                      >
                        <div style={{ flex: 1, height: '1px', background: '#e0e0e0' }}></div>
                        <span style={{ padding: '0 15px' }}>or continue with email</span>
                        <div style={{ flex: 1, height: '1px', background: '#e0e0e0' }}></div>
                      </div>
                    </div>

                    {/* Formulário moderno */}
                    <form className="account__form needs-validation" onSubmit={handleSubmit}>
                      <div className="row g-4">
                        <div className="col-md-6">
                          <div>
                            <label htmlFor="first-name" className="form-label" style={{ fontWeight: '600', color: '#fff' }}>
                              First Name
                            </label>
                            <input
                              type="text"
                              className="form-control modern-input"
                              id="first-name"
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                              placeholder="Enter your first name"
                              style={{
                                width: '100%',
                                padding: '15px 20px',
                                border: '2px solid #e8f0fe',
                                borderRadius: '12px',
                                fontSize: '16px',
                                background: '#f8f9fa',
                                color: '#00D094',
                                transition: 'all 0.3s ease'
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#00D094';
                                e.target.style.background = 'white';
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#e8f0fe';
                                e.target.style.background = '#f8f9fa';
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div>
                            <label htmlFor="last-name" className="form-label" style={{ fontWeight: '600', color: '#fff' }}>
                              Last Name
                            </label>
                            <input
                              type="text"
                              className="form-control modern-input"
                              id="last-name"
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                              placeholder="Enter your last name"
                              style={{
                                width: '100%',
                                padding: '15px 20px',
                                border: '2px solid #e8f0fe',
                                borderRadius: '12px',
                                fontSize: '16px',
                                background: '#f8f9fa',
                                color: '#00D094',
                                transition: 'all 0.3s ease'
                              }}
                              onFocus={(e) => {
                                e.target.style.borderColor = '#00D094';
                                e.target.style.background = 'white';
                              }}
                              onBlur={(e) => {
                                e.target.style.borderColor = '#e8f0fe';
                                e.target.style.background = '#f8f9fa';
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <label htmlFor="account-email" className="form-label" style={{ fontWeight: '600', color: '#fff' }}>
                            Email Address
                          </label>
                          <input
                            type="email"
                            className="form-control modern-input"
                            id="account-email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 20px',
                              border: '2px solid #e8f0fe',
                              borderRadius: '12px',
                              fontSize: '16px',
                              background: '#f8f9fa',
                              color: '#00D094',
                              transition: 'all 0.3s ease'
                            }}
                          />
                        </div>

                        <div className="col-12">
                          <label htmlFor="account-pass" className="form-label" style={{ fontWeight: '600', color: '#fff' }}>
                            Password
                          </label>
                          <div className="form-pass" style={{ position: 'relative' }}>
                            <input
                              type={showPassword ? 'text' : 'password'}
                              className="form-control modern-input"
                              id="account-pass"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder="Enter your password"
                              required
                              style={{
                                width: '100%',
                                padding: '15px 50px 15px 20px',
                                border: '2px solid #e8f0fe',
                                borderRadius: '12px',
                                fontSize: '16px',
                                background: '#f8f9fa',
                                color: '#00D094',
                                transition: 'all 0.3s ease'
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => setShowPassword((prev) => !prev)}
                              className="form-pass__toggle modern-toggle"
                              style={{
                                position: 'absolute',
                                right: '15px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                color: '#00D094',
                                cursor: 'pointer'
                              }}
                            >
                              <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
                            </button>
                          </div>
                        </div>

                        <div className="col-12">
                          <label htmlFor="account-cpass" className="form-label" style={{ fontWeight: '600', color: '#fff' }}>
                            Confirm Password
                          </label>
                          <input
                            type="password"
                            className="form-control modern-input"
                            id="account-cpass"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Re-enter password"
                            required
                            style={{
                              width: '100%',
                              padding: '15px 20px',
                              border: '2px solid #e8f0fe',
                              borderRadius: '12px',
                              fontSize: '16px',
                              background: '#f8f9fa',
                              color: '#00D094'
                            }}
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="trk-btn trk-btn--border trk-btn--primary d-block mt-4 w-100"
                        disabled={loading}
                        style={{
                          background: 'linear-gradient(135deg, #00D094 0%, #00D094 100%)',
                          border: 'none',
                          padding: '15px',
                          borderRadius: '12px',
                          color: 'white',
                          fontWeight: '600',
                          fontSize: '16px',
                          cursor: loading ? 'not-allowed' : 'pointer',
                          transition: 'all 0.3s ease',
                          opacity: loading ? 0.7 : 1
                        }}
                      >
                        {loading ? (
                          <>
                            <i className="fas fa-spinner fa-spin me-2"></i> Creating Account...
                          </>
                        ) : (
                          <>
                            <i className="fas fa-user-plus me-2"></i> Sign Up
                          </>
                        )}
                      </button>

                      {(localError || error) && (
                        <div
                          style={{
                            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%)',
                            color: 'white',
                            padding: '12px 16px',
                            borderRadius: '8px',
                            marginTop: '15px',
                            textAlign: 'center',
                            fontWeight: '500'
                          }}
                        >
                          <i className="fas fa-exclamation-triangle me-2"></i>
                          {localError || error?.message || 'An error occurred while creating your account.'}
                        </div>
                      )}
                    </form>

                    <div className="account__switch text-center mt-4">
                      <p style={{ color: '#6c757d' }}>
                        Already have an account?{' '}
                        <Link
                          to="/login"
                          style={{
                            color: '#fff',
                            textDecoration: 'none',
                            fontWeight: '600',
                            transition: 'color 0.3s ease'
                          }}
                          onMouseEnter={(e) => (e.currentTarget.style.color = '#00D094')}
                          onMouseLeave={(e) => (e.currentTarget.style.color = '#fff')}
                        >
                          Sign In
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Register;